import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "auth_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err?.config?.url || "";
    const isAuthEndpoint = url.includes("/auth/");
    // Only treat a 401 as a session failure for our own protected calls.
    // Skip best-effort/upstream-proxied endpoints so an invalid FloppyData
    // key (which can bubble up) never logs the user out.
    const skip = url.includes("/account/balance") || url.includes("/proxy/");
    if (err?.response?.status === 401 && !isAuthEndpoint && !skip) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function countryFlag(code) {
  if (!code || code.length !== 2) return "🌐";
  return code
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d || e?.message || "Something went wrong";
}
